import { render, staticRenderFns } from "./comentario.vue?vue&type=template&id=2e7bc4f8&scoped=true&"
import script from "./comentario.component.ts?vue&type=script&lang=ts&"
export * from "./comentario.component.ts?vue&type=script&lang=ts&"
import style0 from "./comentario.vue?vue&type=style&index=0&id=2e7bc4f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7bc4f8",
  null
  
)

export default component.exports